export default "__VITE_ASSET__CHmDTcF2__"